import PropTypes from 'prop-types'
import React from 'react'

import { PlaceHolderHouseUrl } from '../../Svg'
import ImageOverlay from './ImageOverlay'

const CardImage = ({
  containsVideoTour,
  containsZillow3dTour,
  featuredImageUrl,
  closestOpenHouseDate,
  closestOpenHouseTime,
  isActive,
  status,
  isRecent,
  highlights
}) => {
  return (
    <div className='CardDesktop-imageContainer'>
      <ImageOverlay
        containsZillow3dTour={containsZillow3dTour}
        containsVideoTour={containsVideoTour}
        closestOpenHouseDate={closestOpenHouseDate}
        closestOpenHouseTime={closestOpenHouseTime}
        isRecent={isRecent}
        isActive={isActive}
        status={status}
        highlights={highlights}
      />

      <picture className='CardDesktop-aspectRatioContent'>
        <source srcSet={featuredImageUrl?.webp} type='image/webp' />
        <img
          src={featuredImageUrl?.jpeg}
          className='CardDesktop-image'
          data-sprinkle='replace-broken-image'
          data-replace-broken-image-url={PlaceHolderHouseUrl}
          alt=''
        />
      </picture>
    </div>
  )
}

CardImage.propTypes = {
  containsVideoTour: PropTypes.bool,
  containsZillow3dTour: PropTypes.bool,
  featuredImageUrl: PropTypes.shape({
    webp: PropTypes.string,
    jpeg: PropTypes.string
  }),
  closestOpenHouseDate: PropTypes.string,
  closestOpenHouseTime: PropTypes.string,
  status: PropTypes.string,
  isActive: PropTypes.bool,
  keyAmenityLabel: PropTypes.string,
  isRecent: PropTypes.bool,
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired
    })
  )
}

export default CardImage
